export default __webpack_public_path__ + "static/media/1_bottom.642c6f6e.png";